import { Button, CardActions, CardContent, Modal, Typography } from '@mui/material';
import { ConfirmCard } from '../Planner/Styles';
import ArrowBackIosNewTwoToneIcon from '@mui/icons-material/ArrowBackIosNewTwoTone';
import React from 'react';

type ConfirmDeleteLineNameParams = {
    open: boolean;
    onClose: () => void;
    onDelete: () => void;
}

export default function ConfirmDeleteLineNameModal({ open, onClose, onDelete }: ConfirmDeleteLineNameParams) {
    return (
        <Modal open={open} onClose={onClose} aria-labelledby="modal-title">
            <ConfirmCard>
                <CardContent sx={{ p: 2 }}>
                    <Typography variant={'h6'} pb={3} id="modal-title">
                        Figyelmeztetés
                    </Typography>
                    <Typography paragraph>
                        Biztosan törölni szeretné a járatnevet?
                    </Typography>
                </CardContent>
                <CardActions sx={{ justifyContent: 'space-around' }}>
                    <Button
                        sx={{ borderRadius: 50 }}
                        variant={'outlined'}
                        size={'small'}
                        onClick={() => onClose()}
                        startIcon={<ArrowBackIosNewTwoToneIcon/>}>
                        Mégsem
                    </Button>
                    <Button variant='contained' size={'small'} sx={{ borderRadius: 50, minWidth: 100 }}
                            onClick={onDelete}>
                        Törlés
                    </Button>
                </CardActions>
            </ConfirmCard>
        </Modal>
    )
}